module.exports = __webpack_public_path__ + "static/media/bm.a523291d.svg";